var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TableBodyRow from "./TableBodyRow";
var TableBody = function (_a) {
    var _b, _c, _d;
    var columns = _a.columns, data = _a.data, onRowClick = _a.onRowClick, draggableTableBodyOptions = _a.draggableTableBodyOptions;
    var renderedRows = data.map(function (d, dataRowIndex) { return (_jsx(TableBodyRow, { dataRowIndex: dataRowIndex, columns: columns, onRowClick: onRowClick, tableData: d, draggableTableBodyRowProps: draggableTableBodyOptions && {
            draggingRowIndex: draggableTableBodyOptions.draggingRowIndex
        } }, dataRowIndex)); });
    return (_jsxs("tbody", __assign({ ref: (_b = draggableTableBodyOptions === null || draggableTableBodyOptions === void 0 ? void 0 : draggableTableBodyOptions.droppableProvided) === null || _b === void 0 ? void 0 : _b.innerRef }, (_c = draggableTableBodyOptions === null || draggableTableBodyOptions === void 0 ? void 0 : draggableTableBodyOptions.droppableProvided) === null || _c === void 0 ? void 0 : _c.droppableProps, { className: " bg-white" }, { children: [renderedRows, (_d = draggableTableBodyOptions === null || draggableTableBodyOptions === void 0 ? void 0 : draggableTableBodyOptions.droppableProvided) === null || _d === void 0 ? void 0 : _d.placeholder] })));
};
export default TableBody;
